import React, { Suspense } from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';

const LazySection = ({ children, fallback = <div style={{ minHeight: '200px' }} />, fadeDelay = 0, className, style, ...props }) => {
  const { targetRef, hasIntersected } = useIntersectionObserver();

  const mergedStyle = {
    contentVisibility: 'auto',
    containIntrinsicSize: '1000px 800px',
    transitionDelay: hasIntersected ? `${fadeDelay}ms` : undefined,
    ...(style || {}),
  };

  const cls = `${className ? className + ' ' : ''}wm-lazy-fade${hasIntersected ? ' is-visible' : ''}`;

  return (
    <div ref={targetRef} className={cls} style={mergedStyle} {...props}>
      {hasIntersected ? (
        <Suspense fallback={fallback}>
          {children}
        </Suspense>
      ) : (
        fallback
      )}
    </div>
  );
};

export default LazySection;